import React, { useEffect, useState } from 'react';
import Base from './../core/Base';
import { isAuthenticated } from '../apiCallsHelper/authapicalls';
import { getUsers, removeUserByAdmin } from '../apiCallsHelper/userapicalls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



const AdminDashboard = () => {

    const { user, token } = isAuthenticated();

    const [usersDetails, setUsersDetails] = useState([]);


    const fetchUsers = () => {
        getUsers(user._id, token)
            .then(data => {
                if (data.error) {
                      toast.error(data.error);
                    // console.log("data.error: ", data.error)
                }
                else {
                    setUsersDetails(data.users);
                      toast.success(data.message);
                    // console.log("data: ", data)
                }
            })
    }



    const handleDeleteUser = (customerId) => {
        // console.log("customerId: ", customerId)
        removeUserByAdmin(user._id, token, customerId).then(data => {
            if (data.error) {
                console.log("data.error: ", data.error)
            }
            else {
                setUsersDetails(data.users)
                console.log("data: ", data)
            }
        })
    }



    useEffect(() => {
        fetchUsers();
    }, [])




    return (
        <>
            <Base>
                <div className='w-[150px] h-full   xs:w-[200px]   sm:w-[250px]    md:w-[520px]    smLaptop:w-[620px]   lg:w-[620px] lg:h-[100%]   xl:w-[1200px]     mx-auto'>
                    <div className='w-[150px]    xs:w-[200px]    sm:w-[250px]    md:w-[520px]    smLaptop:w-[620px]   lg:w-[620px]   xl:w-[1200px]   mt-8 mb-4 text-xl text-center text-blue-900 font-bold'>
                        Admin Panel
                    </div>
                    <div className='w-full h-[100%] pb-10 border-2 border-gray-200 rounded-md'>
                        <div className='p-4 text-xl  font-bold text-[#314778] text-center'>
                            User Details
                        </div>
                        <table className='w-[150px] xs:w-[200px]    sm:w-[250px]    md:w-[520px]    smLaptop:w-[620px]   lg:w-[620px]   xl:w-[1100px]  mx-auto'>
                            <thead className='  bg-[#d6e3ff] text-[#314778] '>
                                <tr>
                                    <th className='py-4 px-2'>
                                        Firstname
                                    </th>
                                    <th className='py-4'>
                                        Lastname
                                    </th>
                                    <th className='py-4'>
                                        Email
                                    </th>
                                    <th className='py-4'>
                                        Account created
                                    </th>
                                    <th className='py-4'>
                                        Verification status
                                    </th>
                                    <th className='py-4'>
                                        Last activity
                                    </th>
                                    {/* <th className='py-4 pr-2'>
                                        Delete
                                    </th> */}
                                </tr>
                            </thead>
                            <tbody className='  text-[#273a63] bg-[#f0f4fa] overflow-y-scroll'>
                                {usersDetails && (usersDetails.map((userDetails) => {
                                    const { _id, fname, lname, email, createdAt, isVerified, lastActivity } = userDetails;
                                    return (
                                        <tr key={_id} className='p-4 text-center'>
                                            <td className='py-4 px-2  w-[200px] break-all '>
                                                {fname}
                                            </td>
                                            <td className='py-4 px-2 w-[100px] break-all '>
                                                {lname ? lname : "-"}
                                            </td>
                                            <td className='py-2 px-2 w-[300px] break-all  '>
                                                {email}
                                            </td>
                                            <td className='py-4 px-2  '>
                                                {new Date(createdAt).toLocaleString("default", { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric' })}
                                            </td>
                                            <td className='py-4 px-2  w-[70px] '>
                                                {isVerified ? "Verified" : "Not verified"}
                                            </td>
                                            <td className='py-4 px-2 w-[200px] '>
                                                {new Date(lastActivity).toLocaleString("default", { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric' })}
                                            </td>
                                            {/* <td className='py-4 px-2 '>
                                                <button onClick={() => handleDeleteUser(_id)}>
                                                    <FontAwesomeIcon icon={faXmark} color="#d41c37" />
                                                </button>
                                            </td> */}
                                        </tr>
                                    )
                                }))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Base>
        </>
    )
}



export default AdminDashboard